import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Button,
} from '@chakra-ui/react';

import ConectarForm from './ConectarForm';

type ConectarModalProps = {
  isOpen: boolean;
  onClose: () => void;
  data?: { nome?: string } | null;
};

export default function ConectarModal({
  isOpen,
  onClose,
  data,
}: ConectarModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay />

      <ModalContent borderRadius="2xl">
        <ModalHeader color="blue.500" borderBottom="1px solid">
          Conectar {data?.nome}
        </ModalHeader>

        <ModalCloseButton />

        <ModalBody>
          <ConectarForm data={data} />
        </ModalBody>

        <ModalFooter gap="3">
          <Button onClick={onClose} variant="ghost">
            Cancelar
          </Button>

          <Button colorScheme="blue">Conectar</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
